const locale = {
    placeholder: 'Vali aeg',
    rangePlaceholder: ['Algusaeg', 'Lõpuaeg'],
};
export default locale;
